import { Component } from '@angular/core';
import { Address } from '@interfaces/address';
import { addresses } from '../../../../../data/account-addresses';
import { AuthenticationService } from '@app/_services/authentication.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AddressInformationComponent } from '@app/shared/components/address-information/address-information.component';
import { UserService } from '@app/_services';
import { ConfirmDialogComponent } from '@app/shared/components/confirm-dialog/confirm-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-page-addresses-list',
    templateUrl: './page-addresses-list.component.html',
    styleUrls: ['./page-addresses-list.component.scss'],
    standalone: true,
    imports: [NgFor, NgIf, RouterLink, TranslateModule]
})
export class PageAddressesListComponent {
    addresses: Address[] = addresses;
    bsModalRef: BsModalRef;
    constructor(private authService: AuthenticationService,
        private toastr: ToastrService,
        private modalService: BsModalService,
        private userService: UserService) { }

    userDetails;

    ngOnInit() {
        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });
    }

    editAddress(index, address) {
        const initialState = {
            addressData: address,
            userId: this.userDetails._id
        };

        this.bsModalRef = this.modalService.show(AddressInformationComponent, { initialState, class: 'modal-lg' });
        this.bsModalRef.content.onClose.subscribe(updatedAddress => {
            if (updatedAddress) {
                this.toastr.success('Address Updated Successfully');
                this.userDetails.addresses[index] = updatedAddress;
            }
        })
    }

    addAddress() {
        const initialState = {
            type: 'add',
            userId: this.userDetails._id
        };

        this.bsModalRef = this.modalService.show(AddressInformationComponent, { initialState, class: 'modal-lg' });
        this.bsModalRef.content.onClose.subscribe(addedAddress => {
            if (addedAddress) {
                this.toastr.success('Address Addedd Successfully');
                this.userDetails?.addresses?.push(addedAddress);
            }
        })
    }

    removeAddress(index, addressId) {
        this.bsModalRef = this.modalService.show(ConfirmDialogComponent, { class: 'modal-sm' });
        this.bsModalRef.content.onClose.subscribe((confirmed) => {
            if (confirmed) {
                this.userService.removeAddress({ _id: addressId }).subscribe((response) => {
                    this.toastr.success(response.msg);
                    this.userDetails.addresses.splice(index, 1);
                }, (error) => {
                    //console.log(error)
                    this.toastr.error('Something Went Wrong');
                });
            }
        });

    }
    setDefaultAddress(addressId) {
        this.userService.setDefaultAddress({ _id: addressId }).subscribe(response => {
            this.userDetails.defaultAddress=response.addressId;
            this.toastr.success(response.msg);
        })
    }
}
